import "./styles.less";

import { Checkbox, Col, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";

import { PropComponentMode } from "../../PropertyInterfaces";
import { useTheme } from "../../../../Styles/ThemeHook";
import { Carousel } from "src/Components/Carousel/web";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { LoadingIcon } from "shared-components/Components/CustomIcons/LoadingIcon/LoadingIcon";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

const { Text, Title } = Typography;

type SimilarsLeadProps = {
	id: string;
	onSend: (propertyIds) => void;
	onCancel: () => void;
	mode: PropComponentMode;
	isSendingLeads: boolean;
	ownerId?: string
};

export default function SimilarsLead({ id, mode, onSend, onCancel, isSendingLeads, ownerId }: SimilarsLeadProps) {
	const [propertyIds, setPropertyIds] = useState<Set<string>>(new Set());
	const { theme } = useTheme();
	const { similars } = usePropertyData();

	useEffect(() => {
		if (similars && similars.length > 0) {
			setPropertyIds(new Set(similars.map(({ id }) => id)));
		}
	}, [])

	const handleChange = e => {
		const id = e.target.value;
		const copy = new Set(propertyIds);
		if (copy.has(id)) copy.delete(id);
		else copy.add(id);
		setPropertyIds(copy);
	};
	const onClickSend = () => onSend(propertyIds);
	const onClickCancel = () => onCancel();

	if (!similars?.length) return null;

	const CarouselItem = ({ data }) => (
		<div className="card-container" key={data.property_id}>
			<Checkbox
				className="similar-lead-checkbox"
				value={data.id}
				checked={propertyIds.has(data.id)}
				onChange={handleChange}
			/>
			<ListingCard data={data} hideCta hideTags staticGallery showExpenses={data.commonExpenses.amount > 0} />
		</div>
	)

	return (
		<div className="similar-lead">
			<Row gutter={[0, theme.spacing.xlSpacing]} className={"similar-lead-row"}>
				<Col span={24}>
					<Row justify={"center"} style={{ textAlign: "center" }}>
						<Col span={24}>
							<Text>{"¡Tu consulta fue enviada con éxito!"}</Text>
						</Col>
						<Col span={24}>
							<Title level={4} className="similar-lead-title">Te recomendamos estas propiedades similares</Title>
						</Col>
						<Col span={24}>
							<Text>Envía una consulta automática y no pierdes ninguna oportunidad</Text>
						</Col>
					</Row>
				</Col>
				<Col span={24}>
					<div className="similar-lead-property-row">
						<Carousel data={similars} ItemComponent={CarouselItem} />
					</div>
				</Col>

				<div className="modal-similar-footer">
					<div className="similar-lead-btn-consultar">
						<button onClick={onClickSend} className="btn-primary" disabled={isSendingLeads || propertyIds.size === 0}>
							{isSendingLeads && <LoadingIcon classes="loading-icon" />}
							Enviar consulta ({propertyIds.size})
						</button>
					</div>
					<div className="similar-lead-btn-cancel">
						<button onClick={onClickCancel} className="btn-third">
							No, gracias
						</button>
					</div>
				</div>
			</Row>
		</div>
	);
}
